module.exports = __webpack_public_path__ + "static/img/bj.d506c310.jpg";